var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7064_597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9 7.61329C24.38 7.09329 23.54 7.09329 23.02 7.61329L16.5 14.12L9.97996 7.59996C9.45996 7.07996 8.61996 7.07996 8.09996 7.59996C7.57996 8.11996 7.57996 8.95996 8.09996 9.47996L14.62 16L8.09996 22.52C7.57996 23.04 7.57996 23.88 8.09996 24.4C8.61996 24.92 9.45996 24.92 9.97996 24.4L16.5 17.88L23.02 24.4C23.54 24.92 24.38 24.92 24.9 24.4C25.42 23.88 25.42 23.04 24.9 22.52L18.38 16L24.9 9.47996C25.4066 8.97329 25.4066 8.11996 24.9 7.61329Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7064_597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.de17474decc99ba5a5d4ba268e069ba5.svg";
export { ForwardRef as ReactComponent };